import React, { ComponentProps, ElementType, ReactNode } from 'react'

import { useId } from '@app/lib/hooks/useId'
import { MergeProps } from '@app/lib/types'

export type FormFieldProps = MergeProps<
  ComponentProps<any>,
  {
    labelElementType?: ElementType
    label?: boolean
    description?: boolean
    error?: boolean
    loading?: boolean
    className?: string
    render: (args: {
      fieldProps: ComponentProps<any>
      labelProps: ComponentProps<any>
      descriptionProps: ComponentProps<any>
      inputProps: ComponentProps<any>
      errorMessageProps: ComponentProps<any>
    }) => ReactNode
  }
>

export const FormField = ({
  label,
  description,
  error,
  loading,
  labelElementType = 'label',
  render,
  ...rest
}: FormFieldProps) => {
  const inputId = useId()
  const labelId = useId(undefined, !!label)
  const descriptionId = useId(undefined, !!description)
  const errorMessageId = useId(undefined, !!error)

  const fieldProps = {
    ...rest
  }

  const labelProps = {
    id: labelId,
    ...(labelElementType === 'label' && { htmlFor: inputId })
  }

  const inputProps = {
    'aria-busy': loading,
    'aria-labelledby': labelId,
    'aria-describedby': descriptionId,
    'aria-invalid': !!error,
    'aria-errormessage': errorMessageId
  }

  const descriptionProps = {
    id: descriptionId
  }

  const errorMessageProps = {
    id: errorMessageId
  }

  return (
    <>
      {render({
        fieldProps,
        labelProps,
        inputProps,
        descriptionProps,
        errorMessageProps
      })}
    </>
  )
}
